export const getMeta = metaName => {
  const element = document.querySelector(
    `meta[name="${metaName}"],meta[property="${metaName}"]`
  );
  return element ? element.content : '';
};
